import React from 'react';
import { TextDefault, TextLead, palette } from '@awarego/awarego-components';
import TableClient from '../../components/table/TableClient';
import { List, ListItem, ListItemText } from '@mui/material';
import { observer } from 'mobx-react';
import { diffValues } from '../../utils/helpers';

function AuditModalContent({ entry }) {
    if (!entry) return null;

    if (entry.type === 'diff') {
        const diff = diffValues(entry.oldValues, entry.newValues);

        return (
            <TableClient
                columns={[
                    { Header: 'Field', accessor: 'key' },
                    {
                        Header: 'Old value',
                        accessor: 'oldVal',
                        Cell: ({ value, row }) => (
                            <TextDefault
                                color={
                                    row.original.status === 'deleted'
                                        ? palette.vibrant.red
                                        : undefined
                                }
                            >
                                {String(value ?? '')}
                            </TextDefault>
                        ),
                    },
                    {
                        Header: 'New value',
                        accessor: 'newVal',
                        Cell: ({ value, row }) => (
                            <TextDefault
                                color={
                                    row.original.status === 'added'
                                        ? palette.evergreen.aspargus
                                        : row.original.status === 'changed'
                                            ? palette.vibrant.gold
                                            : undefined
                                }
                            >
                                {String(value ?? '')}
                            </TextDefault>
                        ),
                    },
                ]}
                data={diff}
                hidePagination
                initialPageSize={10}
            />
        );
    }

    return (
        <List dense>
            {Object.entries(entry.newValues || {}).map(([key, value]) => (
                <ListItem key={key} disablePadding>
                    <ListItemText
                        primary={<TextLead themed>{key}</TextLead>}
                        secondary={String(value)}
                    />
                </ListItem>
            ))}
        </List>
    );
}

export default observer(AuditModalContent);

